<template>
  <div class="navWrapper">
    <el-menu
      class="el-menu-vertical-demo"
      :unique-opened="true"
      :default-active="navIndex"
    >
      <span v-for="(item, index) in navList" :key="index">
        <el-menu-item v-if="!item.IsFolder" :index="item.Id" @click="navClick(item.Id)">
          <span class="navIcon">
            <i v-if="isEl(item.IconClass)" :class="item.IconClass"></i>
            <svg v-else class="icon" aria-hidden="true">
              <use :xlink:href="'#' + item.IconClass"></use>
            </svg>
          </span>
          <span slot="title">{{ item.Title }}</span>
        </el-menu-item>
        <el-submenu v-else :index="item.Id">
          <template slot="title">
            <span class="navIcon">
              <i v-if="isEl(item.IconClass)" :class="item.IconClass"></i>
              <svg v-else class="icon" aria-hidden="true">
                <use :xlink:href="'#' + item.IconClass"></use>
              </svg>
            </span>
            <span>{{ item.Title }}</span>
          </template>
          <el-menu-item
            v-for="(subItem, subIndex) in item.Children"
            :index="subItem.Id"
            :key="subIndex"
            @click="navClick(subItem.Id)"
          >
            <template slot="title">
              <span class="subItem"><span>-</span>{{ subItem.Title }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
      </span>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "Left",
  data() {
    return {
      navIndex: "",
      navList: [],
    };
  },
  methods: {
    isEl(el) {
      return el.split("-")[0] === "el";
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    navClick(key) {
      if (key === this.navIndex) {
        return;
      }
      
      this.$router.push({ name: key });
      this.navIndex = key;
      sessionStorage.setItem("currentIndex", key);
    },
    async getNavList() {
      const res = await this.zzlHttp.post(this.zzlApi.getNav);
      if (res.code === 0) {
        let main_navigation = res.data.main_navigation;
        this.navList = main_navigation;
        let key;
        if (Array.isArray(main_navigation) && main_navigation[0]) {
          let firstObj = main_navigation[0];
          let Children = main_navigation[0].Children;
          let Id = firstObj.Id;
          if (Array.isArray(Children) && Children.length > 0) {
            Id = Children[0].Id;
          }
          if (!this.currentKey) {
            this.navClick(Id);
          } else {
            this.navIndex = this.currentKey;
          }
        }
      }
    },
  },
  computed: {
    currentKey: {
      get() {
        return sessionStorage.getItem("currentIndex");
      }
    },
  },
  mounted() {
    this.getNavList();
  },
};
</script>

<style lang="scss" scoped>
.navWrapper {
  width: 220px;
  height: calc(100vh - 50px);
  background: #FFF;
  overflow: auto;
}
.navWrapper::-webkit-scrollbar {
  width: 0 !important;
} //chrome 和Safari
.navWrapper {
  -ms-overflow-style: none;
} //IE 10+
.navWrapper {
  overflow: -moz-scrollbars-none;
} //Firefox
.navIcon {
  padding: 0 4px;
}
</style>
